var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6359 7.64354C22.9225 7.96844 22.1543 8.18816 21.3486 8.28633C22.1714 7.78145 22.8028 6.98088 23.1003 6.02722C22.3299 6.4947 21.4785 6.83479 20.569 7.01711C19.8442 6.22356 18.8082 5.72803 17.6617 5.72803C15.4632 5.72803 13.6796 7.55706 13.6796 9.81266C13.6796 10.1329 13.7138 10.4438 13.7822 10.743C10.4714 10.5723 7.53667 8.94782 5.57071 6.47366C5.22766 7.07905 5.03163 7.78145 5.03163 8.52942C5.03163 9.94589 5.73482 11.1964 6.80385 11.9292C6.15195 11.9093 5.53651 11.7235 4.99858 11.4196V11.4699C4.99858 13.4497 6.37191 15.1011 8.19541 15.4751C7.86148 15.5709 7.50932 15.6188 7.14576 15.6188C6.88933 15.6188 6.6386 15.5943 6.39584 15.5463C6.903 17.1685 8.3732 18.3501 10.1169 18.3816C8.75386 19.4779 7.03521 20.1312 5.16953 20.1312C4.84814 20.1312 4.53017 20.1125 4.21903 20.0751C5.98213 21.2321 8.07688 21.9088 10.3255 21.9088C17.6537 21.9088 21.6597 15.6854 21.6597 10.2872C21.6597 10.1095 21.6563 9.93187 21.6495 9.75773C22.4279 9.18156 23.1037 8.4628 23.6359 7.64354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.dbd1b22393c087575a51990dfdd01c65.svg";
export { ForwardRef as ReactComponent };